export const shapeColorSettings = {
  fillColor: '#22CDA4',
  strokeColor: '#22CDA4',
}

export const drawingManagerOptions = {
  polygonOptions: {
    fillOpacity: 0.3,
    canBeDeleted: true,
    ...shapeColorSettings,
  },
}



// WEBPACK FOOTER //
// ./src/Components/DrawMap/settings.js